/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { Message } from 'components';
import { Appearance } from 'design/types';
import { URL } from 'routes';

const useQuery = () => new URLSearchParams(useLocation().search);

interface IPrettyMessages {
  [messageKey: string]: string;
}

const prettyMessages: IPrettyMessages = {
  logged_out: 'You have successfully logged out.',
  session_expired: 'Your session has expired. Please log in again.',
  unauthenticated: 'You must be logged in to view that page.',
  no_account_created: 'No Kickfin account found for this Google account.',
};

const AuthLogoutNotice: React.FC = () => {
  const history = useHistory();
  const query = useQuery();
  const message = query.get('message');
  const [timer, setTimer] = useState<number>(null);

  useEffect(() => {
    if (!message) return;

    window.clearTimeout(timer); // Clear any previous timer
    const newTimer = window.setTimeout(() => {
      history.push(URL.Login);
    }, 5000);
    setTimer(newTimer);

    // eslint-disable-next-line consistent-return
    return () => window.clearTimeout(newTimer); // Cleanup function to clear the timer when the component unmounts
  }, [message]);

  if (!message) return null;
  const prettyMessage = prettyMessages[message];

  return <Message dataCy="auth-logout-message" appearance={Appearance.WARNING} message={prettyMessage} />;
};

export default AuthLogoutNotice;
